import get from 'lodash/get'

export default contractStatus

/** @ngInject */
function contractStatus(ReferencesService, ErrorCatcher) {
    let data = null
    let serviceInvoked = false
    const UNKNOWN_STATUS_MSG = 'Notre système n’a pas retrouvé le statut de votre contrat. Contactez-nous pour que nous résolvions ce problème.'

    const realFilter = (value) => get(data, [value, 0, 'label_fr'], UNKNOWN_STATUS_MSG)

    const filterStub = function (value) {
        if (data === null) {
            if (!serviceInvoked) {
                serviceInvoked = true
                ReferencesService.getRefPromise('contractStatus')
                .then((contractStatusMapping) => {
                    data = contractStatusMapping
                })
                .catch(ErrorCatcher.catchError)
            }
            return 'loading ...'
        }
        return realFilter(value)
    }

    filterStub.$stateful = true
    return filterStub
}



// WEBPACK FOOTER //
// ./src/services/filters/contractStatus.js